module.exports = __webpack_public_path__ + "img/uspVan-old.4220c75c.svg";